export const LOAD_JOBS = 'LOAD_JOBS';
export const SET_JOB_PAGINATION = 'SET_JOB_PAGINATION';
export const SET_JOB_SORT = 'SET_JOB_SORT';
export const SET_JOB_FILTERS = 'SET_JOB_FILTERS';
export const RESET_JOB_FILTERS = 'RESET_JOB_FILTERS';
export const TOGGLE_JOB_STATUS = 'TOGGLE_JOB_STATUS';
export const SET_CHECKED_JOB = 'SET_CHECKED_JOB';
export const TOGGLE_JOB_STEPS = 'TOGGLE_JOB_STEPS';
export const BULK_CHECKED_JOB = 'BULK_CHECKED_JOB';
export const ADD_NEW_PALLETE_JOB = 'ADD_NEW_PALLETE_JOB';
export const SET_CALCUL_QUANTITY = 'SET_CALCUL_QUANTITY';
export const ADD_NEW_ERROR_JOB = 'ADD_NEW_ERROR_JOB';
export const REPORT_JOB_ERROR_POPUP = 'REPORT_JOB_ERROR_POPUP';
